import { Component } from '@angular/core';

@Component({
  selector: 'mad-content-panel-container-sidebar',
  templateUrl: './content-panel-container-sidebar.component.html',
  styleUrls: ['./content-panel-container-sidebar.component.scss'],
  standalone: true,
})
export class ContentPanelContainerSidebarComponent {}
